export default __webpack_public_path__ + "static/presse-helles-alkoholfrei-preview-85396715d83b31649202ac7419cbaeb1.jpg";